<template>
  <v-row dense class="flex-grow-0">
    <v-col xs="12" sm="12" md="12" lg="12">
      <v-row dense>
        <v-col xs="12" sm="12" md="12" lg="12">
          <v-slide-group multiple show-arrows v-model="selectedFilters">
            <v-slide-item
              v-for="(filter, index) in rowStatusesComputed"
              :value="filter.id"
              :key="index"
              v-slot:default="{ active, toggle }"
            >
              <v-chip
                filter
                outlined
                @click="toggle"
                :input-value="active"
                :value="filter.id"
                class="mr-2"
                :color="filter.color"
              >
                <v-icon left>{{ filter.icon }}</v-icon>
                <span class="grey--text text--darken-1">
                  {{ filter.title }}
                </span>
              </v-chip>
            </v-slide-item>
          </v-slide-group>
        </v-col>
      </v-row>
      <v-row dense class="ml-8 mt-4">
        <v-spacer />
        <v-col cols="12">
          <v-row dense class="pr-12" justify="end" align="center">
            <v-col cols="auto" v-if="isBreedsResolved || isBreedsUploaded">
              <v-btn text color="success" @click="handleResolvedBreedsClick">
                <v-icon left>mdi-paw</v-icon>
                Resolved breeds
              </v-btn>
            </v-col>
            <v-col cols="auto">
              <v-btn text color="secondary" @click="handleMigrationSummaryOpen">
                Migration Summary
              </v-btn>
            </v-col>
            <v-col cols="auto" v-if="!hideErrors">
              <template v-if="hasErrors">
                <v-btn text @click="() => $refs.errorsDialogRef.open(errors)">
                  <v-icon color="error">mdi-shield-alert-outline</v-icon>
                  <span class="ml-1 text--secondary">
                    This result has {{ errors.length }} errors
                  </span>
                </v-btn>
              </template>
              <template v-else>
                <v-icon color="success">mdi-shield-check-outline</v-icon>
                <span class="ml-1 text--secondary">
                  This result has no errors
                </span>
              </template>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
    <ErrorsDialog ref="errorsDialogRef" />
    <MigrationSummaryDialog ref="migrationSummaryDialogRef" />
    <BreedsResolvingDialog
      is-readonly
      ref="breedsResolvingDialogRef"
      :breed-state-id="$v(breedState, 'id')"
    >
      <template #action>
        <v-btn
          text
          color="success"
          :disabled="breedsLoading || isBreedsUploaded"
          @click="handleResolvedBreedsUpload"
        >
          <v-progress-circular
            indeterminate
            class="mr-2"
            size="22"
            width="2"
            v-if="breedsLoading"
          />
          <v-icon left v-else>mdi-cloud-upload-outline</v-icon>
          Upload
        </v-btn>
      </template>
    </BreedsResolvingDialog>
  </v-row>
</template>

<script>
import { DEFAULTS, BreedsStatesMap } from '@/constants';
import ErrorsDialog from './fileDetails/ErrorsDialog';
import MigrationSummaryDialog from '@/components/dialogs/MigrationSummary/MigrationSummaryDialog';
import BreedsResolvingDialog from '@/components/dialogs/BreedsResolvingDialog';
import { breedsApiV1 } from '@/api/v1';
import { breedsApiV2 } from '@/api/v2';

export default {
  name: 'FileStatusesFilters',
  props: {
    role: {
      type: String,
      default: ''
    },
    filters: {
      type: Object,
      default: () => ({})
    },
    rowStatuses: {
      type: Array,
      default: () => []
    },
    errors: {
      type: Array,
      default: () => []
    },
    hideErrors: {
      type: Boolean,
      default: false
    },
    breedState: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    ErrorsDialog,
    MigrationSummaryDialog,
    BreedsResolvingDialog
  },
  watch: {
    selectedFilters(newFilters) {
      this.$emit('onChange', { filter: 'statuses', value: newFilters });
    }
  },
  data() {
    return {
      search: undefined,
      selectedFilters: [],
      searchTimeout: undefined,
      showStatuses: DEFAULTS.FILTERS_STATUSES,
      breedsLoading: false
    };
  },
  computed: {
    rowStatusesComputed() {
      if (!this.rowStatuses || !this.rowStatuses.length) return [];
      const namedStatuses = this.rowStatuses.map((el) => el.name);
      const statusesToMap =
        this.role === 'customer'
          ? this.showStatuses.customer
          : this.showStatuses.default;

      return statusesToMap.map((name) => {
        const indexOfStatus = namedStatuses.indexOf(name);
        return {
          ...this.rowStatuses[indexOfStatus],
          icon: this.getStatusByName(name).icon,
          color: this.getStatusByName(name).color
        };
      });
    },
    hasErrors() {
      return Boolean(this.errors && this.errors.length);
    },
    isBreedsResolved() {
      return this.breedState?.state === BreedsStatesMap.RESOLVED;
    },
    isBreedsUploaded() {
      return this.breedState?.state === BreedsStatesMap.BREEDS_UPLOADED;
    }
  },
  methods: {
    getStatusByName(statusName) {
      const status = DEFAULTS.ROWS_STATUSES[statusName];
      if (status) return status;
      else {
        console.log('statusName: ', statusName);
        return DEFAULTS.ROWS_STATUSES.not_reviewed;
      }
    },
    handleMigrationSummaryOpen() {
      this.$refs.migrationSummaryDialogRef.open();
    },
    handleResolvedBreedsClick() {
      this.$refs.breedsResolvingDialogRef.open();
    },
    async handleResolvedBreedsUpload() {
      this.breedsLoading = true;
      await (
        this.$store.getters.isMatcherApiV2Enabled ? breedsApiV2 : breedsApiV1
      ).uploadResolvedBreeds(this.breedState.id);
      this.breedState.state = BreedsStatesMap.BREEDS_UPLOADED;
      this.breedsLoading = false;
    }
  }
};
</script>
